import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import api from './api'
import TokenMixin from '@/mixins/TokenMixin'
import PageHeader from './components/layout/PageHeader.vue'
import Fetcher from './prototype/Fetcher'
import CommonFn from './prototype/CommonFn'
import Formatter from './prototype/Formatter'
import Validator from './prototype/Validator'

import i18n from "@/i18n"; // 引入 I18n 套件

import svgIconPlugin from './assets/icons/index'
Vue.use(svgIconPlugin)

import countries from './assets/countries';
import countrycodes from './assets/countrycodes'

Vue.config.productionTip = false

Vue.use(api)
Vue.use(CommonFn)
Vue.use(Validator)
Vue.use(Formatter)
Vue.use(Fetcher)
Vue.mixin(TokenMixin)

Vue.component('PageHeader', PageHeader)

const isDev = (window.location.hostname).includes('localhost') || (window.location.hostname).includes('innpressionhost') || (window.location.hostname).includes('uat');
Vue.prototype.$mediaPath = isDev ? 'https://uatapi.corpplus.hk/media/' : 'https://api.corpplus.hk/media/';
Vue.prototype.$vrAddress = '九龍灣偉業街38號富臨中心A座20樓D室';

function formatText(list, value) {
  if (!value) return '';
  const target = list.find(e => e.value === value);
  return target ? target.text : value;
}

const statusOptions = [
  { value: 'active', text: i18n.t('statusOption.active') },
  { value: 'quit', text: i18n.t('statusOption.quit') },
];
Vue.prototype.$statusOptions = statusOptions;

// -------
const knowFromValues = ['google', 'facebook', 'instagram', 'friend'];
const knowFromOptions = knowFromValues.map(value => {
  return { value: value, text: i18n.t(`knownFromOption.${value}`) };
});
Vue.prototype.$knowFromOptions = knowFromOptions;

// -------
const planTypes = ['create_company_limited', 'create_company_unlimited', 'secretary', 'virtual_office', 'update_corporate_info', 'deregistration', 'scr', 'br', 'stamp'];
const planTypeOptions = planTypes.map(value => {
  return { value: value, text: i18n.t(`planTypeOption.${value}`) }
});
Vue.prototype.$planTypeOptions = planTypeOptions;
Vue.filter('formatPlanType', function (value) { return formatText(planTypeOptions, value); });

// -------
const companyTypes = ['limited', 'unlimit', 'group_assoc'];
const companyTypeOptions = companyTypes.map(value => {
  return { value: value, text: i18n.t(`companyTypeOption.${value}`) }
});
Vue.prototype.$companyTypeOptions = companyTypeOptions;
Vue.filter('formatCompanyType', function (value) { return formatText(companyTypeOptions, value); });

// -------
const addonTypes = ['secretary', 'scr', 'green_box', 'stamp'];
const addonTypeOptions = addonTypes.map(value => {
  return { value: value, text: i18n.t(`addonTypeOptions.${value}`) }
});
Vue.prototype.$addonTypeOptions = addonTypeOptions;
Vue.filter('formatAddonType', function (value) { return formatText(addonTypeOptions, value); });

// -------
const gender = ['M', 'F'];
const genderOptions = gender.map(value => {
  return { value: value, text: i18n.t(`genderOptions.${value}`) }
});
Vue.prototype.$genderOptions = genderOptions;

// -------
const yesNo = ['true', 'false'];
const yesNoOptions = yesNo.map(value => {
  return { value: value, text: i18n.t(`yesNoOptions.${value}`) }
});
Vue.prototype.$yesNoOptions = yesNoOptions;
Vue.filter('formatYesNo', function (value) { return formatText(yesNoOptions, value); });

// -------
const countryOptions = countries.map(item => {
  return { value: item.value, text: `${item.en} ${item.zh}` }
});
Vue.prototype.$countryOptions = countryOptions;
Vue.filter('formatCountry', function (value) { return formatText(countryOptions, value); });

// -------
const regCountryOptions = [
  { text: i18n.t('regCountryOptions.hongkong'), value: 'Hong Kong' },
  { text: i18n.t('regCountryOptions.china'), value: 'China' },
  { text: i18n.t('regCountryOptions.caymanIslands'), value: 'Cayman Islands' },
  { text: i18n.t('regCountryOptions.britishVirginIslands'), value: 'British Virgin Islands' },
  { text: i18n.t('regCountryOptions.taiwan'), value: 'Taiwan' }
];
Vue.prototype.$regCountryOptions = regCountryOptions;
Vue.filter('formatRegCountry', function (value) { return formatText(regCountryOptions, value); });

// -------
const phoneCodeOptions = countrycodes.map(item => {
  return { value: item, text: item }
});
Vue.prototype.$phoneCodeOptions = phoneCodeOptions;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
